import React from "react";
import { Switch, Redirect } from "react-router-dom";
import ProtectedRoute from "router/ProtectedRouteAdmin";

// core components
import routes from "routes.js";

export default function Pages(props) {
  // ref for the wrapper div
  const wrapper = React.createRef();
  // styles
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/maps") {
        return (
          <ProtectedRoute
            path={prop.layout + prop.path}
            isProtected={prop.isProtected}
            credential={prop.rule}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div>
      <div ref={wrapper}>
        <div>
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/auth" to="/auth/login-page" />
          </Switch>
        </div>
      </div>
    </div>
  );
}
